<template>
    <div class="">
        <header-portrate />
        <TabsComp :tabs="tabs" />
        <div class="p-3" :style="`direction:${lang.dir}`">
            <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 class="m-0">{{ lang.purchase_requests || lang.spare_parts_requests || lang.request_spare_parts || 'Spare Parts Requests' }}</h5>
            <div>
                <b-button size="sm" variant="primary" :disabled="loading || actionBusy" @click="loadRequests">{{ lang.refresh || 'Refresh' }}</b-button>
            </div>
            </div>

            <v-simple-table>
            <thead>
                <tr>
                <th class="text-center backBlack">{{ lang.cardid || 'Job Card #' }}</th>
                <th class="text-center backBlack">{{ lang.item_name }}</th>
                <th class="text-center backBlack">{{ lang.qtty }}</th>
                <th class="text-center backBlack">{{ lang.worker_name || 'Requested By' }}</th>
                <th class="text-center backBlack">{{ lang.status || 'Status' }}</th>
                <th class="text-center backBlack">{{ lang.spare_request_availability }}</th>
                <th class="text-center backBlack">{{ lang.action || 'Action' }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="row in requests" :key="row.id">
                <td class="text-center">{{ row.job_card_number || row.job_card_id }}</td>
                <td class="text-center">{{ row.item_name }}</td>
                <td class="text-center">{{ row.quantity }}</td>
                <td class="text-center">{{ row.requested_by_name || '-' }}</td>
                <td class="text-center">{{ statusLabel(row.status) }}</td>
                <td class="text-center">
                    <span v-if="row.inventory_status === 'available'" style="color:green;font-weight:bold;">{{ lang.spare_request_in_stock }}</span>
                    <span v-else-if="row.inventory_status === 'out_of_stock'" style="color:red;font-weight:bold;">{{ lang.spare_request_out_of_stock }}</span>
                    <span v-else>{{ lang.spare_request_manual_review }}</span>
                </td>
                <td class="text-center">
                    <span v-if="row.status === 'pending'">
                        <b-button :disabled="actionBusy" size="sm" class="mr-1" variant="success" @click="updateStatus(row, 'approved')">{{ lang.spare_request_approve }}</b-button>
                        <b-button :disabled="actionBusy" size="sm" class="mr-1" variant="danger" @click="updateStatus(row, 'rejected')">{{ lang.reject }}</b-button>
                        <b-button :disabled="actionBusy" size="sm" variant="info" @click="sendToCustomer(row)">{{ lang.spare_request_send_customer }}</b-button>
                    </span>
                    <span v-else-if="row.status === 'approved'">
                        <b-button :disabled="actionBusy" size="sm" class="mr-1" variant="warning" @click="createPurchaseBill(row)">{{ lang.spare_request_create_bill }}</b-button>
                        <b-button :disabled="actionBusy" size="sm" class="mr-1" variant="danger" @click="updateStatus(row, 'rejected')">{{ lang.reject }}</b-button>
                    </span>
                    <span v-else-if="row.status === 'rejected'">
                        <b-button :disabled="actionBusy" size="sm" class="mr-1" variant="success" @click="updateStatus(row, 'approved')">{{ lang.spare_request_approve }}</b-button>
                    </span>
                    <span v-else-if="row.status === 'awaiting_customer'">{{ lang.spare_request_waiting_customer }}</span>
                    <span v-else-if="row.status === 'customer_will_provide'">
                        <b-button :disabled="actionBusy" size="sm" class="mr-1" variant="warning" @click="customerProvidedIt(row)">{{ lang.spare_request_customer_provided }}</b-button>
                    </span>
                    <span v-else-if="!canReopen(row)">-</span>
                    <!-- Every non-terminal state keeps a way back to Pending, where
                         Approve / Reject / Send-to-customer are on offer again.
                         Without it, one click on Approve or Create Purchase Bill
                         hid those actions permanently with no way to undo. -->
                    <b-button
                        v-if="canReopen(row)"
                        size="sm"
                        variant="outline-secondary"
                        @click="reopenRequest(row)"
                    >{{ lang.spare_request_back_pending }}</b-button>
                </td>
                </tr>
                <tr v-if="!loading && !requests.length">
                <td class="text-center" colspan="7">{{ lang.spare_request_no_data }}</td>
                </tr>
            </tbody>
            </v-simple-table>
        </div>
        <Footer />
    </div>
</template>

<script>
import HeaderPortrate from '@/components/Header-Portrate.vue'
import Footer from '@/components/Footer.vue'
import TabsComp from '@/components/tabsComp.vue'
export default {
  components: {
    HeaderPortrate,
    Footer,
    TabsComp,
  },
  data() {
    return {
      requests: [],
      timerId: null,
      loading:false,actionBusy:false,destroyed:false,
    }
  },
  computed: {
    lang() {
      if (this.$cookies.get(this.$store.state.LangCooki) != null) {
        if (this.$cookies.get(this.$store.state.LangCooki) == 'en') return this.$store.state.lang.en;
        if (this.$cookies.get(this.$store.state.LangCooki) == 'ur') return this.$store.state.lang.ur;
        return this.$store.state.lang.ar;
      }
      if (this.$store.state.deflang == 'en') return this.$store.state.lang.en;
      if (this.$store.state.deflang == 'ur') return this.$store.state.lang.ur;
      return this.$store.state.lang.ar;
    },
    tabs: function() {
        const menu = this.$store.getters['state'].menu;

            const license = this.$store.getters['state'].licenseType.activemenu;
            const alicense = this.$store.getters['state'].licenseType
            let currentMenu = menu[license];
            // console.log("menu",this.$store.getters['state'].licenseType)
            if(!license){
              return false;
            }
            let cMenu = {main: {},sub:[]};
            Object.values(currentMenu).forEach(value =>{
            const cM = localStorage.getItem('currentMenu');
            if(value.main.index == cM){
                cMenu = value.sub;
            }else if(cM == null && value.main.index == 1){
                cMenu = value.sub;
            }
            });

            let t = []
            Object.values(cMenu).forEach(value =>{

                if(this.$route.path == value.href){
                    value.class = "mytab";
                }else{
                    value.class = "mytab4";
                }
                if(this.lang.langname == 'ar'){
                    value.name = value.arname
                }else{
                    value.name = value.enname
                }
                for(let i =0; i< value.groupid.length;i++){
                    if(value.groupid[i] == this.$store.getters['state'].group_id){
                    if(alicense[value.perms[0]] || value.perms[0] == 'any')
                        t.push(value)
                    }
                }

            })

            return t;
    }
  },
  created() {
    this.loadRequests();
    this.timerId = setInterval(() => {
      this.loadRequests();
    }, 30000);
  },
  beforeDestroy() {
    this.destroyed=true;
    if (this.timerId) {
      clearInterval(this.timerId);
      this.timerId = null;
    }
  },
  methods: {
    async postApi(type, payload = {}) {
      const post = new FormData();
      post.append('defBranch', localStorage.getItem('defBranch') || '1');
      post.append('financeYear', localStorage.getItem('financeYear') || '');
      post.append('type', type);
      post.append('auth', this.$cookies.get(this.$store.state.COOKIEPhase));
      Object.keys(payload).forEach((key) => {
        post.append(`data[${key}]`, payload[key]);
      });

      const response = await fetch(this.$store.state.SAMCOTEC.r_path, {
        method: 'POST',
        body: post,
      });
      const result=await response.json();
      if(!response.ok||Number(result?.error?.number)!==200)throw new Error('request_failed');
      return result;
    },
    async loadRequests() {
      if(this.loading||this.actionBusy||this.destroyed)return false;
      this.loading=true;
      try{const res=await this.postApi('get_requests_list',{lang:this.$cookies.get(this.$store.state.LangCooki)});
        if(!Array.isArray(res.results?.data))throw new Error('invalid');
        if(this.destroyed)return false;this.requests=res.results.data;return true;
      }catch(error){if(!this.destroyed)this.$snotify.error(this.lang.spare_request_load_failed,this.lang.alert);return false;}
      finally{this.loading=false;}
    },
    async changeRequest(row,status,extra={}){
      if(this.actionBusy||!row?.id)return false;this.actionBusy=true;
      try{const res=await this.postApi('update_request_status',{request_id:row.id,status,...extra});
        const saved=res.results?.data?.[0];
        if(Number(saved?.id)!==Number(row.id)||saved.status!==status)throw new Error('invalid');
        this.requests=this.requests.map(item=>Number(item.id)===Number(row.id)?{...item,...saved}:item);return true;
      }catch(error){this.$snotify.error(this.lang.spare_request_action_failed,this.lang.alert);return false;}
      finally{this.actionBusy=false;}
    },
    async updateStatus(row, status) {
      if (!row || !row.id) return;
      if (status === 'approved') {
        const confirmText = this.lang.confirm_approve_spare_request || 'Are you sure you want to approve this spare parts request?';
        if (!window.confirm(confirmText)) return;
      }
      if (status === 'rejected') {
        const confirmText = this.lang.confirm_decline_spare_request || this.lang.confirm_delete || 'Are you sure you want to reject this request?';
        if (!window.confirm(confirmText)) return;
      }
      return this.changeRequest(row,status,{note:`Updated from PurchaseRequests view to ${status}`});
    },
    canReopen(row) {
      // 'fulfilled' is the technician confirming the part is physically in
      // their hands -- reopening that would misrepresent what happened, so it
      // stays terminal. Everything else is a decision that can be taken back.
      return !!(row && row.id) && ['approved', 'ordered', 'rejected', 'awaiting_customer', 'customer_will_provide'].includes(row.status);
    },
    async reopenRequest(row) {
      if (!this.canReopen(row)) return;
      const confirmText = this.lang.spare_request_confirm_reopen;
      if (!window.confirm(confirmText)) return;
      return this.changeRequest(row,'pending',{note:'Reopened from PurchaseRequests view'});
    },
    async createPurchaseBill(row) {
      if (!row || !row.id) return;
      const confirmText = this.lang.confirm_create_purchase_bill || 'Are you sure you want to create purchase bill / mark as ordered?';
      if (!window.confirm(confirmText)) return;
      const manual = window.prompt(this.lang.spare_request_bill_id_prompt, '');
      if(manual===null)return false;
      const text=manual.trim();if(text!==''&&(!/^\d+$/.test(text)||!Number.isSafeInteger(Number(text))||Number(text)<1)){this.$snotify.error(this.lang.spare_request_invalid_bill,this.lang.alert);return false;}
      return this.changeRequest(row,'ordered',{purchase_bill_id:text===''?0:Number(text),note:'Marked ordered; no purchase bill was created by this action'});
    },
    statusLabel(status) {
      const labels = {
        pending: this.lang.spare_request_status_pending,
        approved: this.lang.spare_request_status_approved,
        rejected: this.lang.spare_request_status_rejected,
        ordered: this.lang.spare_request_status_ordered,
        fulfilled: this.lang.spare_request_status_fulfilled,
        awaiting_customer: this.lang.spare_request_status_awaiting_customer,
        customer_will_provide: this.lang.spare_request_status_customer_will_provide,
      };
      return labels[status] || status;
    },
    async sendToCustomer(row) {
      if (!row || !row.id) return;
      const priceInput = window.prompt(this.lang.spare_request_price_prompt, '');
      if (priceInput === null) return;
      const price = Number(priceInput);
      if (!price || price <= 0) {
        window.alert(this.lang.spare_request_invalid_price);
        return;
      }
      const isEssential = window.confirm(this.lang.spare_request_confirm_essential);
      if(this.actionBusy)return false;this.actionBusy=true;
      try{const res=await this.postApi('sendSparePartCustomerApproval',{request_id:row.id,price,is_essential:isEssential?1:0});
        if(!Number.isInteger(Number(res.results?.outbox_id))||Number(res.results.outbox_id)<1)throw new Error('not_queued');
        this.actionBusy=false;await this.loadRequests();return true;
      }catch(error){this.$snotify.error(this.lang.spare_request_send_failed,this.lang.alert);return false;}
      finally{this.actionBusy=false;}
    },
    async customerProvidedIt(row) {
      if (!row || !row.id) return;
      const confirmText = this.lang.spare_request_confirm_provided;
      if (!window.confirm(confirmText)) return;
      return this.changeRequest(row,'approved',{note:'Customer provided the part themselves'});
    },
  },
}
</script>
